import React from 'react';
import { TableWrapper } from './TableWrapper';
interface PatternsTabProps {
  searchTerm: string;
}
export function PatternsTab({
  searchTerm
}: PatternsTabProps) {
  const patterns = [{
    name: 'Jueyin Shaoyang Pattern',
    presentation: 'Migraines, TMJ, lateral body pain, anxiety with anger, fibromyalgia, Type A personality',
    leftPoints: 'LR 3, GB 34, GB 41, TH 5, PC 6, LR 14',
    rightPoints: 'LR 3, GB 34, GB 41, TH 5, PC 6, LR 14',
    pulse: 'Wiry pulse, red tongue with yellow coat. Liver fire rising with gallbladder qi stagnation.'
  }, {
    name: 'Jueyin Yangming Pattern',
    presentation: 'IBS, acid reflux, anxiety with digestive upset, stress eating, epigastric pain',
    leftPoints: 'LR 3, ST 36, ST 6, PC 6, LR 13, ST 25',
    rightPoints: 'LR 3, ST 36, ST 6, PC 6, LR 13, ST 25',
    pulse: 'Rapid pulse, red tongue. Liver invading spleen with stomach heat.'
  }, {
    name: 'Shaoyin Shaoyang Pattern',
    presentation: 'Insomnia, depression, burnout, chronic fatigue, night sweats, anxiety',
    leftPoints: 'HT 7, KI 3, GB 34, TH 5, YT 7, KI 6',
    rightPoints: 'HT 7, KI 3, GB 34, TH 5, YT 7, KI 6',
    pulse: 'Thin rapid pulse, red tongue with little coat. Heart-kidney yin deficiency with liver yang rising.'
  }, {
    name: 'Shaoyin Taiyang Pattern',
    presentation: 'Lower back pain, sciatica, kidney deficiency, chronic fatigue, cold limbs',
    leftPoints: 'KI 3, BL 23, HT 7, SI 3, BL 62, KI 6',
    rightPoints: 'KI 3, BL 23, HT 7, SI 3, BL 62, KI 6',
    pulse: 'Deep weak pulse, pale tongue. Kidney yang deficiency with bladder qi weakness.'
  }, {
    name: 'Taiyin Yangming Pattern',
    presentation: 'Respiratory + digestive problems, asthma with bloating, allergies with poor appetite',
    leftPoints: 'LU 9, SP 3, ST 36, LI 4, SP 6, LU 5',
    rightPoints: 'LU 9, SP 3, ST 36, LI 4, SP 6, LU 5',
    pulse: 'Slippery pulse, thick white tongue coat. Spleen dampness with lung qi deficiency.'
  }, {
    name: 'Taiyin Taiyang Pattern',
    presentation: 'Edema, obesity, water retention, chronic diarrhea, dampness accumulation',
    leftPoints: 'SP 9, BL 22, LU 5, SI 4, SP 6, BL 20',
    rightPoints: 'SP 9, BL 22, LU 5, SI 4, SP 6, BL 20',
    pulse: 'Slow slippery pulse, swollen pale tongue. Spleen yang deficiency with bladder qi transformation failure.'
  }, {
    name: 'Yangming In Heat Pattern',
    presentation: 'High fever, infection, inflammation, acute gastritis, constipation with heat signs',
    leftPoints: 'LI 4, ST 44, LI 11, ST 36, ST 25, LI 20',
    rightPoints: 'LI 4, ST 44, LI 11, ST 36, ST 25, LI 20',
    pulse: 'Rapid strong pulse, red tongue with thick yellow coat. Yangming heat with infection.'
  }, {
    name: 'Shaoyang In Heat Pattern',
    presentation: 'Alternating fever/chills, lateral headache, bitter taste, gallbladder inflammation',
    leftPoints: 'GB 34, TH 5, GB 41, TH 23, GB 20, TH 17',
    rightPoints: 'GB 34, TH 5, GB 41, TH 23, GB 20, TH 17',
    pulse: 'Wiry rapid pulse, red tongue with yellow sides. Shaoyang heat with qi stagnation.'
  }, {
    name: 'Taiyang In Heat Pattern',
    presentation: 'UTI, kidney stones, cystitis, posterior headache with heat signs',
    leftPoints: 'BL 23, SI 3, BL 28, SI 8, BL 40, SI 5',
    rightPoints: 'BL 23, SI 3, BL 28, SI 8, BL 40, SI 5',
    pulse: 'Rapid pulse, red tongue with yellow coat. Bladder damp heat with small intestine fire.'
  }];
  return <div className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-625">
      <h2 className="text-3xl font-bold text-gray-800 mb-4 pb-3 border-b-4 border-purple-600" data-id="element-626">
        Pattern-Based Treatment Protocols
      </h2>
      <p className="mb-6 text-gray-700" data-id="element-627">
        <strong data-id="element-628">
          Based on Six Channel Theory combined with Balance Method principles
        </strong>
      </p>
      <TableWrapper searchTerm={searchTerm} data-id="element-629">
        <table className="w-full border-collapse bg-white rounded-lg overflow-hidden shadow-lg" data-id="element-630">
          <thead data-id="element-631">
            <tr className="bg-gradient-to-r from-purple-600 to-purple-800 text-white" data-id="element-632">
              <th className="p-4 text-left text-sm font-semibold" data-id="element-633">
                Pattern Name
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-634">
                Clinical Presentation
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-635">
                LEFT Side Points
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-636">
                RIGHT Side Points
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-637">
                Pulse & Tongue
              </th>
            </tr>
          </thead>
          <tbody data-id="element-638">
            {patterns.map((pattern, index) => <tr key={index} className="border-b border-gray-200 hover:bg-blue-50 transition-colors even:bg-gray-50" data-id="element-639">
                <td className="p-3 font-semibold text-gray-800" data-id="element-640">
                  {pattern.name}
                </td>
                <td className="p-3 text-green-700" data-id="element-641">{pattern.presentation}</td>
                <td className="p-3 font-mono text-red-600 font-medium" data-id="element-642">
                  {pattern.leftPoints}
                </td>
                <td className="p-3 font-mono text-red-600 font-medium" data-id="element-643">
                  {pattern.rightPoints}
                </td>
                <td className="p-3 text-purple-700 italic" data-id="element-644">{pattern.pulse}</td>
              </tr>)}
          </tbody>
        </table>
      </TableWrapper>
    </div>;
}